module.exports = __webpack_public_path__ + "img/Arkafort-logo.de373bd7.svg";